import orderFoodIcon from '../../assets/order-food-icon.png';
import bookYourBuffetIcon from '../../assets/book-your-buffet-icon.png';
import chooseYourMenuIcon from '../../assets/choose-your-menu-icon.png';
import { getDeviceType } from '../../utils/common';

const deviceType = getDeviceType();

export const buttons = [
    {
        buttonTitle: 'Order Your Food',
        link: '/order-food',
        buttonClass: 'order-button order-now-btn',
        containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
        linkClass: 'order-now-btn-link',
        icon: orderFoodIcon,
    },
    // {
    //     buttonTitle: 'Choose Your Menu',
    //     link: '/choose-your-menu',
    //     buttonClass: 'order-button order-now-btn',
    //     containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
    //     linkClass: 'order-now-btn-link',
    //     icon: chooseYourMenuIcon,
    // },
    {
        buttonTitle: 'Book Your Buffet',
        link: '/book-your-buffet',
        buttonClass: 'order-button order-now-btn',
        containerClass: deviceType === 'mobile' ? 'order-button-container text-center mt-10 order-now-btn-mobile-container' : 'order-button-container text-center mt-20 order-now-btn-container',
        linkClass: 'order-now-btn-link',
        icon: bookYourBuffetIcon,
    }
]